var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 3C6.31309 3 3 6.31309 3 10.4C3 14.4869 6.31309 17.8 10.4 17.8C12.0839 17.8 13.6364 17.2376 14.88 16.2903L19.2933 20.7036C19.6838 21.0941 20.317 21.0941 20.7075 20.7036C21.098 20.3131 21.098 19.6799 20.7075 19.2894L16.2937 14.8756C17.2389 13.6327 17.8 12.0819 17.8 10.4C17.8 6.31309 14.4869 3 10.4 3ZM5 10.4C5 7.41766 7.41766 5 10.4 5C13.3823 5 15.8 7.41766 15.8 10.4C15.8 13.3823 13.3823 15.8 10.4 15.8C7.41766 15.8 5 13.3823 5 10.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchBlack);
export default __webpack_public_path__ + "static/media/icon-search-black.57cafda945bf5a4c1509d63b5b2c0229.svg";
export { ForwardRef as ReactComponent };